// 定义英文语言包对象
export default {
    Language: 'Español',
    signIn: 'Iniciar sesión',
    navigateBar: {
        homePage: 'Página de inicio',
        newsInformation: 'Información de noticias',
        productCenter: 'Centro de productos',
        aboutUs: 'Perfil de la empresa',
    },
    title: {
        companyName: 'Ze Technology',
        slogan: 'La búsqueda de la creatividad extrema',
        newsInformation: 'Información de noticias',
        productCenter: 'Centro de productos',
        aboutUs: 'Entrar en la tecnología ze',
        companyNews: 'Noticias de la compañía',
        industryNews: 'Dinámica de la industria',
    },
    aboutUs:{
        aboutUs: 'Perfil de la empresa',
        aboutUsText: 'Fundada en 2007, CCT (hk) Limited es uno de los primeros pioneros en la industria de cigarrillos electrónicos, ha formado un sistema completo de gestión de calidad y una fuerte capacidad de I + d, con más de 400 registros de autorización de patentes en el país y en el extranjero.',
        developmentHistory: 'Proceso de desarrollo',
        corporateCulture: 'Cultura corporativa',
        corporateCultureText1: 'Usuario primero: siempre ponga las necesidades de los usuarios en primer lugar y se comprometa a proporcionar productos y servicios seguros, de alta calidad e innovadores',
        corporateCultureText2: 'Gestión honesta: adherirse a la integridad basada en la integridad, cumplir con las leyes y reglamentos, respetar la ética empresarial y mantener una buena ecología de la industria',
        corporateCultureText3: 'Impulsado por la innovación: fomentar el pensamiento innovador, seguir invirtiendo en investigación y desarrollo, promover el progreso tecnológico y brindar a los usuarios una mejor experiencia de producto',
        corporateCultureText4: 'Cooperación beneficiosa para todos: trabajar con los socios para establecer relaciones de cooperación estables a largo plazo y lograr beneficios mutuos y resultados beneficiosos para todos',
        corporateCultureText5: 'Responsabilidad social: cumplir activamente la responsabilidad social, prestar atención a la protección de los jóvenes, abogar por el consumo racional y contribuir al desarrollo social',
        qualificationAndHonor: 'Certificación internacional de calificación',
        team: 'Estilo de equipo',
        cooperativePartner: 'Socios',
        clickImage: 'Haga clic en la imagen para ver la imagen grande',
    },
    footer: {
        aboutUs: 'Entrar en la tecnología ze',
        newsInformation: 'Información de noticias',
        productCenter: 'Centro de productos',
        contactUs: 'Contáctanos',
        child:{
            developmentHistory: 'Proceso de desarrollo',
            corporateCulture: 'Cultura corporativa',
            qualificationAndHonor: 'Certificación internacional de calificación',
            cooperativePartner: 'Socios',
            companyNews: 'Noticias de la compañía',
            industryNews: 'Dinámica de la industria',
            productIntroduction: 'Introducción del producto',
            email: 'Buzón: garyking0073@gmail.com',
            phone: 'Teléfono: 852 - 88881234',
            address: 'Dirección: FLAT G 2/F LEAPONT CTR 18-28 WO LIU HANG RD FO TAN HONG KONG',
        }
    },
};
